import { Box, Grid, useMediaQuery, useTheme } from '@mui/material';
import bannerbg1 from 'assets/jiwongum/banner-bg4.jpg';
import FlexBox from 'components/flexbox/FlexBox';
import { useState } from 'react';
import CreatorReportTable from './creator-report-table';

export default function CreatorFullContents() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <Grid container>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        sx={{
          width: '100%',
          marginTop: isMobile ? '50px' : '100px',
          padding: isMobile ? '0px' : '0 32px',
        }}
      >
        <Grid item container gap={4} pb={4}>
          <Section1 theme={theme} />

          <CreatorReportTable />
        </Grid>
      </Grid>
    </Grid>
  );
}

const Section1 = ({ theme }) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  const isLaptop = useMediaQuery(theme.breakpoints.down('xl'));

  return (
    <>
      <Grid item container xs={12} height="100%" flexDirection={'row'}>
        <FlexBox
          gap={2}
          sx={{
            width: '100%',
            height: '100%',
            p: isLaptop ? 0 : 2,
            pb: 0,
            flexWrap: 'wrap',
          }}
        >
          <Box
            component="img"
            src={bannerbg1}
            alt="banner"
            sx={{
              width: '100%',
              borderRadius: !isMobile ? '20px' : '0px',
              maxHeight: '300px',
              objectFit: 'cover',
            }}
          />
        </FlexBox>
      </Grid>
    </>
  );
};
